import React from 'react';
import { TimelineParty } from '../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import {
    TransactionDocumentsStage,
    TransactionDocumentVersion,
} from '../../../models/TransactionDocuments/transaction-documents.model';

interface TransactionDocumentsStatusBadgeProps {
    stage: TransactionDocumentsStage;
    requiredDocumentTypes: string[];
    versions: TransactionDocumentVersion[];
    currentUserParty: TimelineParty;
}

interface StatusBadgeContent {
    label: string;
    badgeClass: string;
}

export const isPostingParty = (party: TimelineParty) =>
    party === TimelineParty.Buyer || party === TimelineParty.VetValue;

const getStatusBadgeContent = (
    props: TransactionDocumentsStatusBadgeProps
): StatusBadgeContent => {
    if (props.stage === TransactionDocumentsStage.SellerRedlines) {
        return props.currentUserParty === TimelineParty.Buyer
            ? { label: 'Waiting for Seller Redlines', badgeClass: 'badge-info' }
            : { label: 'No Redlines Uploaded', badgeClass: 'badge-info' };
    }
    if (!isPostingParty(props.currentUserParty)) {
        return { label: 'Waiting for Buyer Drafts', badgeClass: 'badge-info' };
    }
    if (props.versions.length === 0) {
        return { label: 'No Drafts Uploaded', badgeClass: 'badge-info' };
    }
    const hasEveryRequiredType = props.requiredDocumentTypes.every(
        (documentType) =>
            props.versions.some((version) => version.documentType === documentType)
    );
    return hasEveryRequiredType
        ? { label: 'All Initial Drafts Uploaded', badgeClass: 'badge-success' }
        : { label: 'Finish Uploading Drafts', badgeClass: 'badge-warning' };
};

export const TransactionDocumentsStatusBadge = (
    props: TransactionDocumentsStatusBadgeProps
) => {
    const content = getStatusBadgeContent(props);
    return (
        <span className={`badge badge-pill ${content.badgeClass}`}>
            {content.label}
        </span>
    );
};
